export class TravelReason {
  id: string;
  name: string;
}
